import { useEffect, useRef } from "react";

const ProjectCard = ({ link, delay, imgUrl, techStack, projectName }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const card = cardRef.current;
    setTimeout(() => {
      card.classList.add("show");
    }, delay * 1000);
  }, [delay]);

  return (
    <div
      ref={cardRef}
      className="project-card card w-auto group font-poppins mb-5 md:mb-0"
    >
      <a href={link}>
        <figure className="overflow-hidden rounded-lg">
          <img
            src={imgUrl}
            alt="Project"
            loading="lazy"
            className="transition-transform duration-500 object-cover"
          />
        </figure>
      </a>
      <div className="card-body flex-5 px-0 py-3">
        <h2 className="card-title text-white">{projectName}</h2>
        <div className="card-actions justify-start">
          {techStack.map((technology, index) => (
            <div
              key={index}
              className="bg-purple-500 bg-opacity-15 rounded-lg border shadow-lg border-white border-opacity-20 px-2 text-gray-300"
            >
              {technology}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
